import { render } from "./homeArchive.vue?vue&type=template&id=0cac3a63&scoped=true"
import script from "./homeArchive.vue?vue&type=script&lang=js"
export * from "./homeArchive.vue?vue&type=script&lang=js"

import "./homeArchive.vue?vue&type=style&index=0&id=0cac3a63&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cac3a63"]])

export default __exports__